import React from "react";

const ProfileIcon = (props: any) => {
  return (
    <div>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.8">
          <path
            d="M16.6673 18V16.3333C16.6673 15.4493 16.3161 14.6014 15.691 13.9763C15.0659 13.3512 14.218 13 13.334 13H6.66732C5.78326 13 4.93542 13.3512 4.31029 13.9763C3.68517 14.6014 3.33398 15.4493 3.33398 16.3333V18M13.334 6.33333C13.334 8.17428 11.8416 9.66667 10.0007 9.66667C8.1597 9.66667 6.66732 8.17428 6.66732 6.33333C6.66732 4.49238 8.1597 3 10.0007 3C11.8416 3 13.334 4.49238 13.334 6.33333Z"
            stroke={props?.color ?? "black"}
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
  );
};

export default ProfileIcon;
